<script>
    import Fa from 'svelte-fa'
    import { faBullhorn, faProjectDiagram, faRobot } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import ReferralEntries from './referral-entries.svelte'
    import Ztab from '../_common/z/ztab.svelte'

    let tabs = []
    tabs.push({ title: 'Indica', url: '/referral/entries' })
</script>

<Content>
    <div class="root-content">
        <Ztab class="h-space" {tabs}></Ztab>
        <div class="body">
            <Router>
                <Route path="/entries">
                    <ReferralEntries />
                </Route>
            </Router>
        </div>
    </div>
</Content>
